import Slider from 'rc-slider';
import React, { FC } from 'react';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { scale as initialScale } from '@components/frame';

interface SliderWebProps {
  C: ColorFunction;
  scale?: ScaleFunction;
  sliderWidth: number;
  onChange: (value: number | number[]) => void;
  min: number;
  max: number;
  value: number;
}

const SliderWeb: FC<SliderWebProps> = ({ C, scale = initialScale, max, min, onChange, value, sliderWidth }) => {
  return (
    <Slider
      min={min}
      max={max}
      step={1}
      defaultValue={value}
      marks={{
        0: ' ',
        1: ' ',
        2: ' ',
        3: ' ',
        4: ' ',
        5: ' ',
        6: ' ',
      }}
      onChange={onChange}
      styles={{
        track: { backgroundColor: C('Gray/Light/3'), height: scale(4) },
        rail: { backgroundColor: C('Gray/Light/3'), height: scale(4) },
        handle: {
          width: scale(27),
          height: scale(27),
          marginTop: scale(-12),
          opacity: 1,
          backgroundColor: C('Background/Light/Field lighter'),
          boxShadow: `0px 1.2px 3.6px rgba(0, 0, 0, 0.14),
            							0px 6.4px 14.4px rgba(0, 0, 0, 0.15),
            							0px 0px 30px rgba(0, 0, 0, 0.07)`,
          border: 'none',
        },
      }}
      style={{ width: scale(sliderWidth) }}
      dotStyle={{
        backgroundColor: C('Gray/Light/3'),
        borderRadius: 0,
        border: 'none',
        width: scale(4),
        height: scale(8),
        top: scale(-2),
      }}
      activeDotStyle={{ backgroundColor: C('Gray/Light/3') }}
      included={false}
    />
  );
};

export default SliderWeb;
